import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LinkedlnTrackingService {

  private scriptReady: Promise<void>;
  private scriptReadyResolver: (() => void) | null = null;
  private pendingConversions: string[] = [];

  constructor() {
    this.scriptReady = new Promise<void>(resolve => {
      this.scriptReadyResolver = resolve;
    });
  }

  // This is called from main.component.ts
  notifyScriptLoaded() {
    console.log('LinkedIn script loaded. Resolving.');
    if (this.scriptReadyResolver) {
      this.scriptReadyResolver();
      this.scriptReadyResolver = null;
    }
  }

  async trackConversion(conversionId: string) {
    await this.scriptReady;

    if (typeof (window as any).lintrk === 'function') {
      console.log('Tracking LinkedIn conversion:', conversionId);
      (window as any).lintrk('track', { conversion_id: conversionId });
    } else {
      console.warn('LinkedIn tracking function not available even after script load.');
    }
  }
  

}
